import React, { memo } from 'react';

import UserSeats from './UserSeats';

interface PurchasedSeatsProps {
  totalProSeats: number;
  totalStandardSeats: number;
}

const PurchasedSeats = ({ totalProSeats, totalStandardSeats }: PurchasedSeatsProps) => {
  return (
    <div className="mt-8 flex flex-wrap items-center justify-between gap-x-16 gap-y-8 xs:justify-normal xs:gap-56">
      <UserSeats className="bg-pro-gold" count={totalProSeats} text="Pro" />
      <UserSeats className="bg-primary-magenta" count={totalStandardSeats} text="Standard" />
    </div>
  );
};

export default memo(PurchasedSeats);
